module.exports = __webpack_public_path__ + "static/media/speaker_ASHRAE_BAC_Bushby.b9feb67d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_ASHRAE_BAC_Bushby.jpg
// module id = 239
// module chunks = 0